'use strict';

angular.module('controllers')
.directive('selectRow', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr, ctrl) {
			element.bind('click', function (event) {
				var currentElement = angular.element(event.currentTarget);

				if (element.hasClass('selected')) {
					//element.removeClass('selected');
					//scope.model.selected = false;
					//scope.selected =  [];
				}else{
					angular.element( document.querySelector( '.selected' )).removeClass('selected');
					element.addClass('selected');
					//scope.model.selected = true;
					//delete scope.selected[scope.model.id];
					///scope.selected[scope.model.id]= scope.model;

				}
				//console.log(scope.selected);

			});
		}
	}
})
